import { useEffect, useState } from 'react';

import { getId } from '../../utils/dialog/collections';

import useSSR from './useSSR';

const createElement = (id: string): HTMLElement => {
  const el = document.createElement('div');
  el.setAttribute('id', id);
  return el;
};

const usePortal = (
  selectId: string = getId(),
  // 원하는 위치 아래에 모달을 띄우기 위해 생성하는 함수
  getContainer?: () => HTMLElement | null
): HTMLElement | null => {
  const id = `${selectId}`;
  const { isBrowser } = useSSR();
  const [elSnapshot, setElSnapshot] = useState<HTMLElement | null>(isBrowser ? createElement(id) : null);

  useEffect(() => {
    const customContainer = getContainer ? getContainer() : null;
    const parentElement = customContainer || document.body;
    const hasElement = parentElement.querySelector<HTMLElement>(`#${id}`);
    const el = hasElement || createElement(id);

    if (!hasElement) {
      parentElement.appendChild(el);
    }
    setElSnapshot(el);
  }, []);

  return elSnapshot;
};

export default usePortal;
